import * as utils from '../utils';
export default function sameHeight(elem, callback) {
	var max;

	function setSize() {
		// reset max
		max = 0;

		// firs remove styles or previous applied size
		[].forEach.call(elem, function(elem) {
			elem.style.height = null;
		});

		// get natural height
		[].forEach.call(elem, function(elem) {
			max = Math.max(max, elem.offsetHeight);

		});

		// set height of max elem
		[].forEach.call(elem, function(elem) {
			elem.style.height = max + "px";

		});
	}
	if (elem[0].getAttribute("data-same-height-enabled") === "true") {
		setSize();
		return;
	}

	setSize();
	elem[0].setAttribute("data-same-height-enabled", "true");
	window.addEventListener('resize', utils.throttle(setSize, 400));

}


//////////////////
// WEBPACK FOOTER
// ./src/js/components/sameHeight.js
// module id = 53
// module chunks = 0